// extracted by mini-css-extract-plugin
export default {"list":"contact-list_list__6PpQb","item":"contact-list_item__YrRrv","text":"contact-list_text__PYV82","button":"contact-list_button__mpPrS"};